import {Stack} from '@customink/pigment-react';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import ProductDetailsRow from 'product_details_page/ProductDetailsRow';
import KeyBenefitItem from 'product_details_page/ProductDetailsSection/KeyBenefitItem';
import {trackProductDescriptionPageAccordionClick} from 'utils/analytics';

export default function KeyBenefits({keyBenefits}) {
  const [detailsAccordionExpanded, setDetailsAccordionExpanded] =
    useState(false);

  return (
    <ProductDetailsRow
      title="Key Benefits"
      accordionSummary="Key Benefits"
      accordionExpanded={detailsAccordionExpanded}
      accordionWrapperSx={{px: 0}}
      useAccordionAlways
      onAccordionClick={() => {
        setDetailsAccordionExpanded(!detailsAccordionExpanded);
        trackProductDescriptionPageAccordionClick(
          'key benefits',
          detailsAccordionExpanded
        );
      }}>
      <Stack gap="1rem">
        {keyBenefits.map((keyBenefit) => (
          <KeyBenefitItem
            key={keyBenefit.title}
            description={keyBenefit.description}
            title={keyBenefit.title}
            noBackground
          />
        ))}
      </Stack>
    </ProductDetailsRow>
  );
}

KeyBenefits.propTypes = {
  keyBenefits: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    })
  ).isRequired
};
